import { InternalTransferTransactionModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../shared';

export class TransferPayment extends DomainEntity<InternalTransferTransactionModelDto> {
    constructor(dto: InternalTransferTransactionModelDto) {
        super(dto);
    }

    public createDefault(): this {
        throw new Error('Method not implemented.');
    }

    public get amount() {
        return this.dto.amount || 0;
    }

    public set amount(amount) {
        this.dto.amount = amount;
    }

    public get fromAccount() {
        return this.dto.fromAccount.accountDisplayLabel;
    }

    public get toAccount() {
        return this.dto.toAccount.accountDisplayLabel;
    }

    public get frequency() {
        return this.dto.parentFrequencyModel
            ? this.dto.parentFrequencyModel.summary
            : this.dto.frequencyModel?.summary;
    }

    public get frequencyOccurrence() {
        return this.dto.frequency;
    }

    public get frequencyModel() {
        return this.dto.frequencyModel;
    }

    public get frequencyDescription() {
        return this.dto.frequencyDescription;
    }

    public get parentFrequency() {
        return this.dto.parentFrequencyModel;
    }

    public get endDate() {
        return this.dto.endDate;
    }

    public get isRecurring() {
        return this.dto.frequency !== 'OneTime';
    }

    public get memo() {
        return this.dto.memo;
    }

    public set memo(memo) {
        this.dto.memo = memo;
    }

    public get transferDate() {
        return this.dto.transferDate;
    }

    public set transferDate(transferDate) {
        this.dto.transferDate = transferDate;
    }

    public get nextTransferDate() {
        return this.dto.nextTransferDate;
    }

    public get completedApprovals() {
        return this.dto.completedApprovals;
    }

    public get completedApprovalCount() {
        return this.dto.completedApprovalCount || 0;
    }

    public get numberOfApprovalsNeeded() {
        return this.dto.numberOfApprovalsNeeded;
    }

    public get status() {
        return this.dto.status;
    }

    public get id() {
        return this.dto.id;
    }

    public get updatedBy() {
        return this.dto.updatedBy ?? '';
    }

    public get audit() {
        return this.dto.audit ?? [];
    }

    public get transactionId() {
        return this.dto.transactionId;
    }

    public get createdDate() {
        return this.dto.createdDate;
    }

    public get permissions() {
        return this.dto.permissions?.map(p => p.permission) ?? [];
    }

    public get messageType() {
        return this.dto.messageType;
    }

    public get message() {
        return this.dto.message;
    }
}
